<template>
  <el-container>
    <el-header class="skill-group-content">
      <h3 class="title">
        <div class="block">
          <span>坐席管理</span>
        </div>
      </h3>
    </el-header>
    <el-container style="height: calc(100% - 70px)">
      <el-aside class="side" style="overflow-y: hidden;">
        <div class="side-title">
            <span>
              <h5>坐席分组</h5>
            </span>
          <!-- TODO 导入导出 -->
        </div>
        <div class="side-content">
          <TreeSearch
            :treeRef="treeRef"
            :attributes="grouptreeProp"
            :options="groupData_"
            :nodeKey="nodeKey"
            :accordion="false"
            :expandedKeys="expandedKeys"
            :addNode="addNode"
            :defaultHideNodeId="defaultWbGroupId"
            :deleteNode="deleteNode"
            :editNode="editNode"
            :moveNode="moveNode"
            :btnsStatus="loadBtnsStatus"
            :defaultCurrentNodeKey="defaultCurrentNodeKey"
            v-if="groupData_.length>0"
            :getClickNode="getClickNode"
            :updateExpendNodes="updateExpendNodes"
          />
        </div>
      </el-aside>
      <el-main class="section">
        <Contant
        :changeViewList="changeViewList"
        :pTotal="pTotal"
        />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Contant from './Contant'
import TreeSearch from '@/views/auth/components/treeSearch/TreeSearch'
import { addUserGroup, editUserGroup, deleteUserGroup, getUserGroupChildLevel } from '@/api/user'
import { mapActions } from 'vuex'
export default {
  name: '',
  data() {
    return {
      dialogTableVisible: false,
      treeRef: 'wemgrTree',
      nodeKey: 'id',
      pTotal: 0,
      defaultCurrentNodeKey: ''
    }
  },
  props: {
    changeView: Function,
    grouptreeProp: Object
  },
  computed: {
    groupData_() {
      return this.$store.state.user.userGroupTree
    },
    defaultWbGroupId() {
      return this.$store.state.user.defaultWbGroupId
    },
    expandedKeys() {
      return this.$store.state.user.curExpandedKeys
    },
    storeCurGroupId() {
      return this.$store.state.user.curGroupId
    },
    loadBtnsStatus() {
      const btnsStatus = {}
      btnsStatus.add = this.$authUtis.hasButtonAuth('aicc-bp', '/ug/addUserGroup_post')
      btnsStatus.edit = this.$authUtis.hasButtonAuth('aicc-bp', '/ug/editUserGroup_put')
      btnsStatus.delete = this.$authUtis.hasButtonAuth('aicc-bp', '/ug/deleteUserGroup_delete')
      btnsStatus.move = this.$authUtis.hasButtonAuth('aicc-bp', '/ug/getUserGroupChildLevel_get')
      return btnsStatus
    }
  },
  watch: {
    storeUserData(val) {
      if (val) {
        this.userData = val
      }
    },
    groupData_(val) {
      this.defaultLoadGroupId()
    }
  },
  components: {
    Contant,
    TreeSearch
  },
  mounted() {
    this.defaultLoadGroupId()
    // this.defaultCurrentNodeKey = this.storeCurGroupId ? this.storeCurGroupId : this.defaultWbGroupId
  },
  methods: {
    ...mapActions('user', ['_listUser', '_getUserGroupTree']),
    defaultLoadGroupId() {
      const showGroupId = this.storeCurGroupId ? this.storeCurGroupId : this.defaultWbGroupId
      const defaultItem = this.groupData_.length > 0 ? this.groupData_.filter(item => item.id === showGroupId) : []
      let defId = ''
      if (defaultItem.length > 0) {
        defId = showGroupId
      } else {
        if (this.groupData_.length > 0) {
          defId = this.groupData_[0].id
        }
      }
      this.$store.commit('user/setCurGroupId', { groupId: defId })
      this.defaultCurrentNodeKey = defId
      // console.log('----------' + this.defaultCurrentNodeKey)
    },
    updateExpendNodes(list) {
      this.$store.commit('user/setCurExpandedKeys', { keys: list })
    },
    changeViewList(target) {
      this.changeView(target)
    },
    getClickNode(node) {
      // console.log(node.id)
      this.$store.commit('user/setCurGroupId', { groupId: node.id })
      this._listUser({ groupId: node.id, pageNum: 1, pageSize: 10 })
        .then(res => {
          this.pTotal = res.data.total
        })
        .catch(() => {})
    },
    addNode(newNode, data) {
      const name = newNode.label
      const parentId = data ? (data.parentId === 0 ? '' : data.parentId) : ''

      addUserGroup({ name, parentId }).then(res => {
        if (res.code === 2000) {
          this.$store.commit('user/setCurGroupId', { groupId: res.data.id })
          this._getUserGroupTree({ type: '0' })
          this.$message.success(res.data.msg)
          this._listUser({ groupId: res.data.id, pageNum: 1, pageSize: 10 })
        } else {
          this.$message.error(res.msg)
          this._getUserGroupTree({ type: '0' })
        }
      })
    },
    deleteNode(node, data) {
      const id = data.id
      deleteUserGroup({ id }).then(res => {
        if (res.code === 2000) {
          this._getUserGroupTree({ type: '0' })
          this.$message.success(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    editNode(node, data) {
      const id = data.id
      const name = data.name
      const parentId = data.parentId
      editUserGroup({ id, name, parentId }).then(res => {
        if (res.code === 2000) {
          this._getUserGroupTree({ type: '0' })
          this.$message.success(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    moveNode(draggingNode, dropNode, dropType, MAX_LEVEL) {
      const _data = draggingNode.data
      const userGroupBH = _data.bh
      getUserGroupChildLevel({ userGroupBH }).then(res => {
        if (res.code === 2000) {
          const childLevel = res.data
          if ((dropType === 'inner' && (dropNode.level + childLevel) > MAX_LEVEL) ||
              (dropType !== 'inner' && (dropNode.level + childLevel - 1) > MAX_LEVEL)) {
            this.$message.warning('移动后该节点连带子节点层级超过' + MAX_LEVEL + '层，故无法移动到此！')
            this._getUserGroupTree({ type: '0' })
          } else if (dropType !== 'inner' && dropNode.level === draggingNode.level &&
            (((_data.parentId === null || _data.parentId === '') && (dropNode.data.parentId === null || dropNode.data.parentId === '')) || _data.parentId === dropNode.data.parentId)) {
            this.$message.warning('坐席组不允许同一父节点下平级移动')
            this._getUserGroupTree({ type: '0' })
          } else {
            if (dropType === 'inner') {
              _data.parentId = dropNode.data.id
            } else {
              _data.parentId = dropNode.data.parentId
            }
            this.editNode(draggingNode, _data)
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    confirm() {
      this.dialogTableVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.skill-group-content {
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
}

.el-aside {
  &.side {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
    .side-title {
      flex: 0 0 40px;
    }

    .side-content {
      display: flex;
      flex-direction: column;
      /*flex: 1;*/
      flex: 1 0 auto;
      height: calc(100% - 50px);
      .comp-tree {
        display: flex;
        flex-direction: column;
        /*flex: 1;*/
        flex: 1 0 auto;

        ::v-deep .el-tree {
          flex: 1;
          height: auto !important;
          /*overflow-y: auto;*/
        }
      }
    }
  }
}

.zxtitle {
  line-height: 40px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
